<template>
  <page-layout title="대출수수료 계산">
    <template v-slot:search>
      <commission-calculation-search-bar
        :fee-data="feeData"
      />
    </template>
    <template v-slot:table>
      <commission-calculation-table
        @feeData="getFeeData"
      />
    </template>
  </page-layout>
</template>
<script>
import PageLayout from "@/common/layout/PageLayout.vue";
import CommissionCalculationSearchBar
  from "@/pages/Loan/components/CommissionCalculation/CommissionCalculationSearchBar.vue";
import CommissionCalculationTable from "@/pages/Loan/components/CommissionCalculation/CommissionCalculationTable.vue";

export default {
  name: "CommissionCalculation",
  components: {CommissionCalculationTable, CommissionCalculationSearchBar, PageLayout},
  data() {
    return {
      feeData: {}
    }
  },
  methods: {
    getFeeData(data) {
      this.feeData = data;
    }
  }
}
</script>